import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTab, MatTabGroup, MatTabHeader } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownItem } from 'projects/admin/src/app/models/commonModel';
import { WarningApplicationComponent } from '../../shared/component/warning-application/warning-application.component';
import { ExternalFilingRequestService } from '../../shared/services/exemptionFilingRequest';
import { ExternalCommonService } from '../../shared/services/external.common.service';
import { InternalTabTypes } from 'projects/admin/src/app/models/exemptionFilling';
import { ConfirmModalComponent } from '../../shared/component/confirm-modal/confirm-modal.component';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-registry-download',
  templateUrl: './registry-download.component.html',
  styleUrls: ['./registry-download.component.scss'],
})
export class RegistryDownloadComponent implements OnInit {
  form!: FormGroup;
  signatureText: string = `By checking the box below, you are certifying the following:`;
  agreeText: string = `I intend and agree that the electronic submission of the information set forth herein constitutes my signature of the exemption registration.`;
  SignatureTab!: FormGroup;
  data: any;
  @ViewChild('tabs') tabs!: MatTabGroup;
  selectedIndex: number = 0;
  requestId: number = 0;
  isLoading = false;
  externalStatusTypes: DropdownItem[] = [];
  sendToMode = null;
  selectedTab = 'Registry Download';
  isError = false;
  amount: any;
  candownload = false;
  fiscompleted = false;
  downloadType = '';
  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    private router: ActivatedRoute,
    private exemptionFilingRequestService: ExternalFilingRequestService,
    private commonService: ExternalCommonService,
    private routerService: Router
  ) {}

  ngOnInit(): void {
    this.buildForm();
    const id = this.router.snapshot.params.id;
    if (id) {
      this.requestId = +atob(id);
      this.loadData();
    }
    this.router.queryParams.subscribe((params) => {
      console.log(params);
      if (params?.ifpf != null) {
        this.fiscompleted = true;
        this.selectedIndex = 2;
        this.selectedTab == InternalTabTypes.PaymentTab;

        if (params.ifpf == btoa('true')) {
          const dialogRef = this.dialog.open(ConfirmModalComponent, {
            data: {
              title: 'Warning',
              warning: true,
              message: `Online payment failed. \n Please select Ok. \n You will be redirected to the Exemption Registry website.`,
            },
            disableClose: true,
          });
          dialogRef.afterClosed().subscribe((res) => {
            window.location.href =
              'https://www.tn.gov/workforce/injuries-at-work/employers/employers/wc-exemption-registry.html';
          });
        } else if (params.ifpf == btoa('false')) {
          this.candownload = true;
        }
      }
    });
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      console.log(this.tabs);
      this.tabs._handleClick = this.interceptTabChange.bind(this);
    });
  }
  interceptTabChange(tab: MatTab, tabHeader: MatTabHeader, idx: number) {
    return false;
  }
  tabChanged(event: any) {
    console.log(event);
    this.selectedTab = event.tab?.textLabel;
  }

  Continue() {
    this.setNextTabIndex();
  }
  onOnlinePayment() {
    this.routerService.navigateByUrl(
      '/registrydownloadpaynow/' + btoa(this.requestId + '')
    );
  }
  private loadData() {
    this.isLoading = true;
    forkJoin({
      exemptionData: this.commonService.getRegistryDownload(this.requestId),
    }).subscribe(({ exemptionData }) => {
      this.data = exemptionData;
      console.log(this.data);
      this.populateFormData();
      this.isLoading = false;
    });
  }
  populateFormData() {
    setTimeout(() => {
      this.form.patchValue(this.data);
      this.sendToMode = this.data?.downloadTypeId;
      if (this.sendToMode == 1) {
        this.amount = 1000;
        this.downloadType = 'Full Registry Download';
      }
      if (this.sendToMode == 2) {
        this.amount = 50;
        this.downloadType = 'Prior Month\'s Registry Activity';
      }
      if (this.sendToMode == 3) {
        this.amount = 50;
        this.downloadType = 'Prior Week\'s Registry Activity';
      }
    });
  }

  saveAndContinue() {
    this.validateAndSave();
  }
  download() {
    this.commonService.downloadLink(this.sendToMode).subscribe((response) => {
      var blob = new Blob([response.body as BlobPart], { type: 'text/csv' });
      var url = window.URL.createObjectURL(blob);
      window.open(url, '_blank', '');
    });
  }

  private openFile = (data: any) => {
    const byteCharacters = data.body;
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    var blob = new Blob([byteArray], { type: 'text/csv' });
    var url = window.URL.createObjectURL(blob);
    window.open(url, '_blank', '');
  };

  close() {
    window.location.href =
      'https://www.tn.gov/workforce/injuries-at-work/employers/employers/wc-exemption-registry.html';
  }

  viewSample() {
    window.open('./assets/Registry.Download.Schema.pdf', '_blank');
  }

  private setNextTabIndex() {
    this.selectedIndex += 1;
  }

  previousStep() {
    this.selectedIndex -= 1;
  }

  validateAndSave() {
    console.log(this.selectedTab);
    if (this.selectedTab == 'Registry Download') {
      if (this.sendToMode == null) {
        this.isError = true;
        return;
      } else {
        this.setNextTabIndex();
      }
    }
    if (this.selectedTab == InternalTabTypes.SignatureTab) {
      if (this.form.invalid) {
        if (this.form.controls['signatureICertify'].invalid) {
          this.dialog.open(ConfirmModalComponent, {
            data: {
              title: 'Warning',
              warning: true,
              message: `You have not indicated "I Certify". \n Click OK to go back.`,
            },
            disableClose: true,
          });
        }
      } else {
        this.form.controls['id'].patchValue(this.requestId);
        this.form.controls['id'].updateValueAndValidity();
        console.log(this.form.value);
        this.isLoading = true;
        this.commonService
          .updateRegistryDownload(this.requestId, this.form.value)
          .subscribe(
            (res: any) => {
              this.isLoading = false;
              console.log(res);
              this.setNextTabIndex();
            },
            (error) => {
              this.isLoading = false;
            }
          );
      }
    }
  }

  onCheck(value: any, event: any) {
    if (!event.checked) value = null;
    this.sendToMode = value;
    this.form.controls['downloadTypeId'].patchValue(value);
    this.form.controls['downloadTypeId'].updateValueAndValidity();
    if (this.sendToMode == 1) {
      this.amount = 1000;
      this.downloadType = 'Full Registry Download';
    }
    if (this.sendToMode == 2) {
      this.amount = 50;
      this.downloadType = 'Prior Month\'s Registry Activity';
    }
    if (this.sendToMode == 3) {
      this.amount = 50;
      this.downloadType = 'Prior Week\'s Registry Activity';
    }
  }

  private buildForm() {
    this.form = this.fb.group({
      id: [this.requestId],
      downloadTypeId: [''],
      signatureFirstName: ['', Validators.required],
      signatureMiddleName: [''],
      signatureLastName: ['', Validators.required],
      signatureTitle: [''],
      signatureSuffix: [''],
      signatureICertify: new FormControl('', [
        (control) => {
          return !control.value ? { required: true } : null;
        },
      ]),
    });
  }

  onCancel() {
    let dialogRef = this.dialog.open(WarningApplicationComponent, {
      data: {
        title: 'Warning',
        message: `Your application has not been completed. Leaving the page will cancel your application and no data will be saved. \n Click Leave to leave the page \n Click OK to continue entering your application?`,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res.data == 'cancel') {
        const ereqType = this.externalStatusTypes.find(
          (x: { code: string }) => x.code == 'EXTSUBCANCELLED'
        )?.id;
        this.exemptionFilingRequestService
          .updateExternalRequestStatus(this.requestId, ereqType)
          .subscribe((res) => {
            this.routerService.navigateByUrl('/search');
          });
      }
    });
  }
}
